import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { pageColors } from "../../mock";
import { useCart } from "../../context/CartContext";
import { PhotoGallery } from "../../components/PhotoGallery";
import { ArrowLeft, ShoppingBag, Check } from "lucide-react";

const PRICE = 180;
const PHOTOS = [
  "/img/jordan_1.webp",
  "/img/jordan_2.webp",
  "/img/jordan_3.webp",
  "/img/jordan_4.webp",
];

const Jordan = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [added, setAdded] = useState(false);
  const [sold, setSold] = useState(false);

  useEffect(() => { document.title = "TMM|JORDAN"; }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bodega/status`)
      .then((r) => r.json())
      .then((d) => setSold(!!(d.items || []).find((i) => i.id === "jordan-aj5-fire-red-12")?.sold))
      .catch(() => {});
  }, []);

  const addToCart = () => {
    addItem({
      id: "jordan-aj5-fire-red-12",
      name: "Air Jordan 5 Retro 'Fire Red' — size 12",
      price: PRICE,
      image: "/img/jordan_1.webp",
      description: "Air Jordan 5 Retro 'Fire Red' — white/black/fire red.",
      tag: "jordan",
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="brand-page">
        <button className="feed-back" onClick={() => navigate("/brands/mjs-bodega")} data-testid="jordan-back">
          <ArrowLeft size={16} /> Back to MJ's Bodega
        </button>

        <header className="brand-hero-center" data-testid="jordan-hero">
          <img src="/img/jordan_mark.png" alt="Jordan" className="brand-hero-mark jordan" />
        </header>

        <section className="brand-preorder-preview jordan-preview" data-testid="jordan-preview">
          <PhotoGallery images={PHOTOS} alt="Air Jordan 5 Retro Fire Red" testId="jordan-gallery" />
        </section>

        <section className="brand-preorder-panel" data-testid="jordan-preorder-panel">
          <div className="brand-preorder-name">Air Jordan 5 Retro 'Fire Red'</div>
          <div className="brand-preorder-color" data-testid="jordan-color">White / Black / Fire Red</div>
          <div className="brand-preorder-price" data-testid="jordan-price">${PRICE}</div>
          {sold && <div className="bodega-sold-badge" data-testid="jordan-sold-badge">SOLD</div>}

          <div className="brand-size-block">
            <div className="brand-size-label">Size</div>
            <div className="brand-size-row" role="radiogroup" aria-label="Select size">
              <button
                type="button"
                role="radio"
                aria-checked="true"
                className="brand-size-chip active"
                data-testid="jordan-size-12"
              >
                12
              </button>
            </div>
          </div>

          <button
            type="button"
            className="btn-solid btn-huge"
            onClick={addToCart}
            disabled={sold}
            data-testid="jordan-add-btn"
          >
            {sold ? (
              "SOLD OUT"
            ) : added ? (
              <>
                <Check size={18} /> Added — size 12
              </>
            ) : (
              <>
                <ShoppingBag size={18} /> Add to cart — size 12
              </>
            )}
          </button>
        </section>
      </div>
    </>
  );
};

export default Jordan;
